import { ReactComponent as External } from "../../../../../images/icons/external-link.svg";
import { Link } from "react-router-dom";
import T from "../../../../../common/i18n/Text";
import {IForWhom} from "../ForWhomSection";
import React from "react";
import "./ForWhomCard.css"

interface Props {
    forWhom: IForWhom;
}
const ForWhomCard = ({forWhom}: Props) => {
    return (
        <li className="for-whom-card">
            <img src={forWhom.img} alt="card" />
            <h3>{forWhom.category}</h3>
            <ul>
                {forWhom.reasons.map((advantage, i) => <li key={`advantage-${i}`}>{advantage}</li>)}
            </ul>
            <Link className="flex items-center gap-[10px] text-[20px] leading-[30px] mt-auto underline" to="/games">
                <T path="games.buttons.openGamesList" />
                <External />
            </Link>
        </li>
    )
}

export default ForWhomCard
